var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForensic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 269,
    viewBox: "0 0 268 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 268,
    height: 268,
    rx: 134,
    fill: "white",
    fillOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_7684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.752 67.0456C154.752 62.862 151.371 59.4705 147.201 59.4705C143.03 59.4705 139.649 62.862 139.649 67.0456V70.9936C139.649 75.1772 143.03 78.5688 147.201 78.5688C151.371 78.5688 154.752 75.1772 154.752 70.9936V67.0456Z",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 79C182.686 79 180 76.3511 180 73.0835V70",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 79C113.314 79 116 76.3511 116 73.0835V70",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 121C113.314 121 116 123.649 116 126.916V130",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 121C181.686 121 179 123.649 179 126.916V130",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.763 62.049V78.5687",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.651 62.049V78.5687",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.308 97.6917C134.308 93.508 130.927 90.1165 126.756 90.1165C122.586 90.1165 119.205 93.508 119.205 97.6917V101.64C119.205 105.823 122.586 109.215 126.756 109.215C130.927 109.215 134.308 105.823 134.308 101.64V97.6917Z",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.209 97.6917C175.209 93.508 171.828 90.1165 167.658 90.1165C163.487 90.1165 160.106 93.508 160.106 97.6917V101.64C160.106 105.823 163.487 109.215 167.658 109.215C171.828 109.215 175.209 105.823 175.209 101.64V97.6917Z",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.207 90.1165V109.215",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.096 90.1165V109.215",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.318 90.1165V109.215",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.752 128.325C154.752 124.142 151.371 120.75 147.201 120.75C143.03 120.75 139.649 124.142 139.649 128.325V132.273C139.649 136.457 143.03 139.849 147.201 139.849C151.371 139.849 154.752 136.457 154.752 132.273V128.325Z",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.763 120.75V135.975",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.651 120.75V135.975",
    stroke: "#39BBD3",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.4 163.216C133.372 166.041 133.914 169.199 133.914 172.654",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7912 223.916C59.8902 193.997 71.2264 159.416 86.7844 148.769C90.6862 146.104 95.5973 144.611 100.779 144.302",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1458 111.362C61.3796 111.201 61.6135 111.028 61.8596 110.868C68.4324 106.365 75.7929 103.071 83.6457 101.072",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0771 155.727C50.8313 142.6 58.6226 131.003 70.1926 123.094C74.8329 119.924 80.0025 117.506 85.5167 115.902",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0044 206.125C52.9484 180.291 55.4347 151.347 77.8239 136.036C81.7134 133.371 86.1199 131.422 90.8956 130.225",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.401 165.202C148.807 167.632 149.016 170.137 149.016 172.678C149.016 181.179 142.087 188.594 133.631 188.088C113.999 186.903 123.501 169.495 111.722 161.883C104.558 157.257 97.8991 159.625 95.1666 161.513C82.8088 170.051 88.9754 189.1 92.7049 195.564C103.623 214.515 121.138 219.561 127.12 221.238",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.524 175.035C103.77 183.535 106.798 202.56 132.769 204.237C141.521 204.805 146.752 202.189 150.69 198.636",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.453 152.754C176.84 152.754 200.663 128.875 200.663 99.4189C200.663 69.9631 176.84 46.0844 147.453 46.0844C118.066 46.0844 94.2434 69.9631 94.2434 99.4189C94.2434 128.875 118.066 152.754 147.453 152.754Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.425 136.764L220.923 172.333",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_7684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 184,
    fill: "white",
    transform: "translate(44 43)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForensic);
export default __webpack_public_path__ + "static/media/forensic.e5bd0eaa5af894b86d51515c84734403.svg";
export { ForwardRef as ReactComponent };